import mySolidarity from './mySolidarity/mySolidarity';
import solidarityRouting from './solidarityRouting/solidarityRouting';

let solidarityFeatures = angular.module('solidarity.features', [
  mySolidarity,
  solidarityRouting,
])
  .name;

export default solidarityFeatures;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/solidarity.features.js